import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  boxSelectItems: {
    marginBottom: '16px'
  },

  sectionLabel: {
    color: theme.app.colors.text.primary,
    width: '100%',
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 500,
    marginTop: '8px'
  },
  boxSelectDiv: {
    minWidth: 120,
    height: 150,
    padding: 12,
    borderRadius: 10,
    backgroundColor: '#f5f3f1',
    border: `2px solid ${theme.palette.secondary.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',

    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
    }
  },
  boxSelectDivSelected: {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: '#f0e6e3',
    boxShadow: '0 2px 4px rgba(120, 74, 66, 0.2)'
  },
  boxSelectContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  boxSelectEmoji: {
    width: 40,
    height: 40,
    objectFit: 'contain'
  },
  boxSelectLabel: {
    color: theme.app.colors.text.primary,
    fontSize: theme.app.typography.small.fontSize,
    textAlign: 'center',
    cursor: 'pointer',
    margin: 0
  },

  boxSelectGroup: {
    width: '100%',
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }
}))
